import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase-config";
import { useLocation, useNavigate } from "react-router-dom";
import Editor from "../components/Editor";
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../redux/userReducer'
import { getFirebaseDocs, getUrlParams, randomString } from '../common'
import Header from '../components/Header'
import Tabs from "../components/Tabs";
import Input from "../components/Input";
import MyDropzone from "../components/MyDropzone";
import Dropdown from "../components/Dropdown";

const EntertainmentActivity = () => {

    const [confirmDelete, setConfirmDelete] = useState(false)

    const [editId, setEditId] = useState(false)

    const [isAdding, setIsAdding] = useState(false)
    const [name, setName] = useState('')
    const [excerpt, setExcerpt] = useState('')
    const [priority, setPriority] = useState(1)
    const [video, setVideo] = useState('')
    const [thumbnail, setThumbnail] = useState('')
    const [audio, setAudio] = useState('')
    const [audioTitle, setAudioTitle] = useState('')

    const [loading, setLoading] = useState(false)
    const [mode, setMode] = useState('')
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation();

    const [parentsCategories, setParentsCategories] = useState([])

    const userInfo = useSelector(state => state.user.user)



    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const uid = user.uid
                if (!userInfo) {
                    getUserInfo(uid)
                }
            } else {
                // User is signed out
                navigate('/login')
                // ...
            }
        })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        if (userInfo && userInfo.role === 'admin') {
            fetchActivity()
        }
    }, [userInfo])

    const getUserInfo = async (uid) => {
        // console.log('uid', uid)
        setLoading(true)
        const userData = await (await getDoc(doc(db, 'users', uid))).data()
        console.log('userData', userData)
        if (!userData) {
            toast.error('User doesn\'t exist. Taking you to login page.')
            setLoading(false)
            setTimeout(async () => {
                await signOutUser()
                navigate('/login')
            }, 3000)
            return
        }
        dispatch(setUser({ ...userData, id: uid }))
    }

    const signOutUser = async () => {
        await auth.signOut();
    }

    const fetchActivity = async () => {
        const params = getUrlParams()
        if (!params || !params.category) {
            navigate('/')
            return
        }
        const categoryInfo = await (await getDoc(doc(db, 'entertainment-categories', params.category))).data()
        setMode(categoryInfo.name)
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'entertainment-activities'), where('parentId', '==', params.category), orderBy('priority', "desc"))))

        setParentsCategories(docs)
    }

    const saveCategory = async () => {
        const params = getUrlParams()
        if (editId) {
            await setDoc(doc(db, 'entertainment-activities', editId), { name, audio: audio || '', audioTitle: audioTitle || '', parentId: params.category, excerpt, video, thumbnail, priority: parseInt(priority) })
        } else {
            await addDoc(collection(db, 'entertainment-activities'), { name, audio: audio || '', audioTitle: audioTitle || '', parentId: params.category, excerpt, video, thumbnail, priority: parseInt(priority) })

        }
        setEditId('')
        setIsAdding(false)
        fetchActivity()
    }

    const goBack = () => {
        const canGoBack = location.key !== 'default';
        console.log('can', canGoBack)
        if (canGoBack) {
            navigate(-1)
        } else {
            navigate('/')
        }
    }


    const deleteActivity = async () => {
        if (editId) {
            if (!confirmDelete) {
                setConfirmDelete(true)
                return
            }
            await deleteDoc(doc(db, 'entertainment-activities', editId))
            setConfirmDelete(false)
            window.location.reload()
        }
    }


    return <div className="container">
        <Header />
        {isAdding ? <>
            <h2>Add a {mode} Activity</h2>
            <Input bold type={'text'} errorMessage={''} errors={[]} name={'name'} value={name} setValue={setName} label={'Name'} />


            <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000', }}>Video</label>
            <MyDropzone allowVideo storageLocation={`Activities/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'video'} image={video} updateImage={(doc) => setVideo(doc)} />

            <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000', }}>Thumbnail</label>
            <MyDropzone storageLocation={`Activities/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'thumbnail'} image={thumbnail} updateImage={(doc) => setThumbnail(doc)} />

            <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Audio</label>
            <MyDropzone storageLocation={`Activities/${randomString()}`} allowAudio customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'icon'} image={audio} updateImage={(doc) => setAudio(doc)} />

            <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Audio Title</label>
            <MyDropzone storageLocation={`Activities/${randomString()}`} allowAudio customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'icon'} image={audioTitle} updateImage={(doc) => setAudioTitle(doc)} />



            <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000', }}>Excerpt</label>
            <Editor data={excerpt} setData={setExcerpt} />

            <Input bold type={'text'} errorMessage={''} errors={[]} name={'priority'} value={priority} setValue={setPriority} label={'Priority'} />


            <div style={{ width: '200px', margin: '10px auto', display: 'flex', flexDirection: 'column' }}>
                <button disabled={!name || !excerpt || !thumbnail || !video || !priority || !parseInt(priority)} onClick={saveCategory}>Save</button>
                <button style={{ margin: '20px auto' }} className="textButton" onClick={() => { setIsAdding(false); setEditId('') }}>Cancel</button>
                <button disabled={!editId} style={{ backgroundColor: 'red' }} onClick={deleteActivity}>{confirmDelete ? 'Confirm Delete' : 'Delete'}</button>

            </div>

        </> : <>
            {/* <Tabs tabs={modes} currentTab={mode} setCurrentTab={setMode} /> */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <button className="textButton" style={{ marginLeft: '0' }} onClick={goBack}> {'←Back'}</button>
                <button className="textButton" style={{ marginLeft: 'auto' }} onClick={() => { setIsAdding(true); setEditId('') }}>+ Add New</button>
            </div>

            <h2>{mode} Activities</h2>
            <table>
                <thead>
                    <tr>
                        <th>
                            Name
                        </th>
                        <th>
                            Video
                        </th>
                        <th>
                            Priority
                        </th>
                        <th>
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {parentsCategories.map(({ id, name, audio, thumbnail, excerpt, priority, video }) => <tr key={id}>
                        <td>
                            {name}
                        </td>
                        <td>
                            <img src={thumbnail} style={{ height: '150px' }} />
                        </td>
                        <td>
                            {priority}
                        </td>
                        <td>
                            <div style={{ display: 'flex' }}>
                                {/* <button className="textButton" onClick={() => navigate(`/categories?category=${id}`)}>View</button> */}
                                <button className="textButton" onClick={() => { setIsAdding(true); setEditId(id); setPriority(priority); setThumbnail(thumbnail); setName(name); setVideo(video); setExcerpt(excerpt); setAudio(audio) }}>Edit</button>
                            </div>
                        </td>
                    </tr>)}
                </tbody>
            </table>
        </>}
    </div>
}

export default EntertainmentActivity